import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Router, ActivatedRoute} from '@angular/router';
import {Store, select} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {ParticleService} from '@core/services/particle.service';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {take, takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {ConversationComponentName} from "../../../task-manager/collaboration/store/collaboration.constants";
import {CreateChatConversationAction} from "../../../task-manager/collaboration/store/collaboration.action";
import {ContentScope} from "@shared/commands/command-base";
import {CreateChatConversationCommand} from "../../../task-manager/collaboration/store/collaboration.command";
import {ViewSynchronizerService} from "@shared/components/platform-sidebar/store/view-synchronizer.service";
import {CollaborationState} from "../../../task-manager/collaboration/store/collaboration.reducer";
import { CommandService } from '@core/services/command.service';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';


@Component({
    standalone: false,
    selector: 'particle-single-case-content',
  templateUrl: './single-case-content.component.html',
  styleUrls: ['./single-case-content.component.scss']
})
export class SingleCaseContentComponent implements OnInit, OnDestroy {

  sourceType: string;
  sortFieldKey: string;
  sortDirection: string;
  isClose = false;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  caseId: string;
  breadcrumbKey: any;
  breadcrumbs$: any;

  constructor(private router: Router, private store: Store<IDac6ReporterState>,
              private particleService: ParticleService,
              private particleStore: Store<ParticleState>,
              protected commandService: CommandService,
              private viewSynchronizerService: ViewSynchronizerService,
              private collaborationStore: Store<CollaborationState>,
              private activatedRoute: ActivatedRoute,
              private snackBarService: SnackBarService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private dialogService: DialogService,
              private fileStoreCommonService: FileStoreCommonService,
              private queryState: Store<IQueryState>) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      }
    ];
    this.sourceType = 'CaseContentLink';
    this.sortFieldKey = 'ModifiedDate';
    this.sortDirection = 'dsc';
    this.breadcrumbKey = 'BreadcrumbByCaseId';
    this.invalidateSubject = new InvalidateSubject();
  }

  startDataSurvey() {

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.caseId = params.caseId;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      config.Parameters['CASE_ID'] = this.caseId;
      this.breadcrumbs$ = this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.caseId});
    });

    // const activityInfo = {type: 'Tool', 'id': 'dac6-reporting-overview', 'title': 'Overview', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  onGridCellValueChange(event) {
    console.log(event);
    const linkType = event.item.cells['LinkItemType'].value;
    const itemId = event.item.cells['LinkItemId'].value;
    if (event.fieldDefinition && event.fieldDefinition.key === 'LinkItemType') {

      if(linkType.startsWith('Arrangement'))
      {
        this.router.navigateByUrl(`dac6-reporter/arrangement/${itemId}`);
      }
      else
      {
        switch (linkType) {
          case 'Monthly Filing':
            this.router.navigateByUrl('dac6-reporter/filing/monthly');
            break;
          case 'Quarterly Filing':
            this.router.navigateByUrl('dac6-reporter/filing/quarterly');
            break;
          case 'Annual Filing':
            this.router.navigateByUrl('dac6-reporter/filing/annual');
            break;
          case 'Other Filing':
            this.router.navigateByUrl('dac6-reporter/filing/other');
            break;
          case 'Pre-Arrangement':
            this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${itemId}`);
            break;
          case 'Form':
            this.router.navigateByUrl(`dac6-reporter/filing-manager/forms/${itemId}`);
            break;
        }
      }
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Start Conversation':
          this.getChatForThisCase(event);
          break;
        case 'Open':
          switch (linkType) {
            case 'Montly Filing':
              this.router.navigateByUrl('dac6-reporter/filing/monthly');
              break;
            case 'Arrangement':
              this.router.navigateByUrl(`dac6-reporter/arrangement/${itemId}`);
              break;
            case 'Pre-Arrangement':
              this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${itemId}`);
              break;
            case 'Form':
              this.router.navigateByUrl(`dac6-reporter/filing-manager/forms/${itemId}`);
              break;
          }
        case 'OpenCaseFolder':
          this.navigateToCaseFolder(event);
      }
      return;
    }
    // if(event.action){
    //   switch(event.action.id){
    //     case 'Open':
    //       break;
    //     case 'Edit':
    //       this.edit(event);
    //       break;
    //     case 'OpenCaseFolder':
    //       this.navigateToCaseFolder(event);
    //       break;
    //     case 'Start Conversation':
    //       break;
    //     case 'Move to Arrangements':
    //       break;
    //     case 'CreateMonthlyFiling':
    //       this.createMonthlyFiling(event.item);
    //       break;
    //     case 'CreateQuearterlyFiling':
    //       this.createQuarterlyFiling(event.item);
    //       break;
    //     case 'Delete Pre-Arrangement':
    //       const command = new ArrangeMentsDeleteCommand([event.item.id]);
    //       this.commandService.executeCommand(command).subscribe(state=>{
    //         if (state) {
    //           this.invalidateSubject.invalidate();
    //           this.snackBarService.showInformation('Task assignment successful');
    //         }
    //       });
    //       break;
    //   }
    // }
    console.log(event);
  }

  getChatForThisCase(event) {
    this.viewSynchronizerService.setComponentToInitialState();
    if (!event.item.cells['CaseGUID']) {
      return;
    }
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      relativePath = relativePath.replace('/Filings', '');
      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });
      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);

    }
  }


  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  close(){
    this.isClose = true;
  }

}
